<template>
  <section id="other-method" name="card-payment" class="other-method">
    <div class="other-method__container">
      <header v-if="oneClickProvider == 'googlePay' || oneClickProvider == 'applePay'">
        <div class="text">{{ $t("paywall.or") }}</div>
      </header>

      <div class="cards">
        <img :src="`${mediaBaseUrl}paywall/visa.svg`" width="48px" alt="visa" />
        <img :src="`${mediaBaseUrl}paywall/mastercard.svg`" width="50px" alt="mastercard" />
      </div>

      <div class="other-method__form">
        <form id="card-subscription-form" class="form__content">
          <label>
            <span>{{ $t("paywall.form.nameTitle") }}</span>
            <input
              v-model="userInfo.name"
              :placeholder="$t('paywall.form.namePlaceholder')"
              class="name"
              name="name"
              type="text"
              required
            />
          </label>

          <label>
            <span>Email</span>
            <input
              v-model="userInfo.email"
              placeholder="mail@example.com"
              class="name"
              name="email"
              type="email"
              required
              />
          </label>

          <label>
            <span>{{ $t("paywall.form.address") }}</span>
            <input
              v-model="userInfo.address"
              :placeholder="$t('paywall.form.address')"
              class="name"
              name="billing_address[line1]"
              type="text"
              required
            />
          </label>

          <label>
            <span>{{ $t("paywall.form.cardTitle") }}</span>
            <div class="stripe-input" id="card-form"></div>
          </label>

          <button class="submit-button" @click="() => tracker.report('User_click_subscription_get_plan4')">
            {{ $t("paywall.form.button") }}
          </button>

          <!-- <custom-button
            @click="() => tracker.report('User_click_subscription_get_plan4')"
            :animation="true"
            :primary="true"
          >
            {{ $t("subscription.getMyPlan") }}
          </custom-button> -->

          <div class="protection-text">
            {{ $t("paywall.protectionText") }}
          </div>

          <!-- <p class="info">
            {{ $t("subscription.otherMethod.form.terms[0]") }}<br>
            {{ $t("subscription.otherMethod.form.terms[1]", {email: supportEmail}) }}
          </p> -->
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { EventBus } from "../../../EventBus";

const PM_ONE_CLICK = 0;
const PM_CARD = 1;

export default {
  inject: ["mediaBaseUrl"],
  props: {
    oneClickProvider: {
      default: null,
      required: false,
    },
  },

  data() {
    return {
      initialized: false,
      supportEmail: `support@${location.hostname}`,
      loading: false,
      activeMethod: null,
      activePaymentElement: null,
      cardNumber: "",
      userInfo: {
        name: null,
        email: null,
        address: null,
        city: null,
      },
      features: [
        {
          icon: "/media/inpulse-template-ad/payment/cancel.svg",
          title: "Cancel anytime",
          text:
            "Contact our customer support at <a href='mailto:support@" +
            location.hostname +
            "'>support@" +
            location.hostname +
            "</a> to cancel your subscription",
        },
        {
          icon: "/media/inpulse-template-ad/payment/secure.svg",
          title: "See secure payment",
          text: "Your information is protected by the most advanced data encryption technology",
        },
        {
          icon: "/media/inpulse-template-ad/payment/payment-methods.svg",
          title: "Accepted payment methods",
          text: "ApplePay, Credit Cards",
        },
      ],
      methods: [
        {
          id: "apple-pay-form",
          available: false,
          name: "ApplePay",
          icon: "/media/inpulse-template-ad/payment/apple-pay.png",
          price: {
            plan: "29.99",
            discount: "29.99",
            total: "0.00",
          },
        },
        {
          id: "card-subscription-form",
          available: true,
          initialized: false,
          name: "Credit Card",
          icon: "/media/inpulse-template-ad/payment/visa-mastercard.png",
          price: {
            plan: "29.99",
            discount: "29.99",
            total: "0.00",
          },
        },
      ],
      verticalPadding: 24,
    };
  },

  methods: {
    handlePaymentSelect(event, method) {
      if (this.activeMethod === method) {
        return;
      }

      if (this.activePaymentElement) {
        this.activePaymentElement.style.maxHeight = null;
      }

      this.activeMethod = method;
    },

    completePayment(status, event) {
      event && event.complete(status);

      if (status == "success") {
        EventBus.$emit("download-app");
      } else {
        EventBus.$emit("hide-preloader");
      }
    },

    updateUserInfo(userInfo) {
      console.log('[after quiz] update user info:', userInfo)

      if (userInfo) {
        this.userInfo.name = `${userInfo.first_name} ${userInfo.last_name}`
        this.userInfo.email = userInfo.email

        if (!this.initialized) {
          this.init()
        }
      }
    },

    init() {
      let trialEnd = new Date()
      trialEnd.setDate(trialEnd.getDate() + 3)
      console.log('Trial end:', trialEnd)

      this.initialized = true

      var paymentRequest = this.session.stripeAPI.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'PREMIUM VERSION',
          amount: 100,
        },
        requestPayerEmail: true,
        requestPayerName: true,
        disableWallets: [
          'link',
        ],
      });

      paymentRequest.canMakePayment().then((result) => {
        if (result) {
          this.paymentRequest = paymentRequest
          console.log('Cane make payments:', result)
        } else {
          console.log('Apple Pay or Google Pay support not found. Check the pre-requisites above and ensure you are testing in a supported browser.')
          this.tracker.report('can_make_payment_false')
        }

        // Initialize card form
        const form = document.querySelector('#card-subscription-form')
        const cardElement = form.querySelector('#card-form')

        console.log('Form:', form)
        console.log('CardElement:', cardElement)
        console.log('Session info:', this.session.info)
        console.log('Plan ID:', this.session.info.plan.id)

        this.stripeCheckoutForm = new StipeCheckoutForm(
          form,
          cardElement,
          this.session.stripeAPI,
          this.session.info,
          EventBus
        );
      });

      paymentRequest.on('paymentmethod', async (event) => {
        console.log('OnPamynet method:', event)

        this.updateUserEmail();

        if (event.paymentMethod) {
          this.createSubscription(event.paymentMethod, event)
        } else {
          alert('Something went wrong')
        }
      });

      paymentRequest.on('cancel', () => {
        EventBus.$emit('hide-preloader')
      })

      paymentRequest.on('error', () => {
        EventBus.$emit('show-preloader')
      })
    },

    /**
     * Updates sesison.info.user.email with data from userInfo.email.
     * If value missing update will not be performed
     */
    setUserEmail(email) {
      try {
        this.session.setUserEmail(email);
      } catch(e) {
        console.error('Failed to update user session email', e);
      }
    },

    /**
     * Creates subscription on server side with given paymentMethod and event
     * @param {string|object} token Stripe card or payment method (for Apple Pay) token.
     * @param {object} event Apple Pay event object (required to complete payment widget with success or error)
     */
    createSubscription(paymentMethod, event) {
      this.setUserEmail(this.userInfo.email);
      this.stripeCheckoutForm
        .createOneClickSubscription(paymentMethod)
        .then((success) => {
          let result = success ? "success" : "error";
          this.completePayment(result, event);
        });
    },

    updateUserInfo(userInfo) {
      console.log("[payment modal] update user info:", userInfo);

      if (userInfo) {
        this.userInfo.name = `${userInfo.first_name} ${userInfo.last_name}`;
        this.userInfo.email = userInfo.email;
      }

      if (!this.methods[PM_CARD].initialized) {
        this.methods[PM_CARD].initialized = true;
        EventBus.$emit("init-card-form");
      }

      EventBus.$emit(
        "get-oneclick-provider-details",
        (is_availabe, provider_name) => {
          if (is_availabe) {
            this.methods[PM_ONE_CLICK].available = true;
            let applePayForm = document.querySelector("#apple-pay-form");
            applePayForm &&
              applePayForm.addEventListener("submit", (event) => {
                event.preventDefault();

                EventBus.$emit("click-start-now", true);
              });
          }
        }
      );
    },

    clickStartNow() {
      if (this.oneClickCheckoutAvailable) {
        this.paymentRequest.show();
      } else {
        let offsetTop = document.querySelector("#other-method").offsetTop;
        window.scrollTo(0, offsetTop);
      }
    },

    startTrial() {
      this.tracker.report("start_trial");
    },
  },

  computed: {
    session() {
      return this.$root.$children[0].$refs.session;
    },
    tracker() {
      return this.$root.$children[0].$refs.tracker;
    },
  },

  mounted() {
    console.log("Payment Modal mounted");

    if (window.ApplePaySession) {
      this.tracker.report("apple_pay_available");
    } else {
      this.tracker.report("apple_pay_not_available");
    }

    EventBus.$emit("get-user-info");
  },

  created() {
    EventBus.$on("user-info-saved", this.updateUserInfo);
    EventBus.$on("user-info", this.updateUserInfo);
  },

  destroyed() {
    EventBus.$off("user-info-saved", this.updateUserInfo);
    EventBus.$off("user-info", this.updateUserInfo);
  },
};
</script>

<style scoped lang="sass">
.other-method__container
  header
    .text
      font-size: 16px
      font-weight: 400
      line-height: 24px
      text-align: center
      color: #6D6D6D

  .cards
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    gap: 12px
    margin-top: 14px
    margin-bottom: 28px

.form__content
  display: flex
  flex-direction: column
  box-shadow: none
  padding: 16px 0 0

  .submit-button
    width: 100%
    padding: 14px 45px
    border-radius: 4px
    background: #55b5a6
    font-size: 18px
    font-weight: 500
    line-height: 27px
    text-align: center
    color: #FFFFFF
    margin-top: 14px
    border: none
    cursor: pointer

  label
    display: flex
    align-items: flex-start
    flex-direction: column
    gap: 6px
    margin-bottom: 10px

    span
      font-size: 16px
      font-weight: 400
      line-height: 24px
      text-align: left
      color: #000000

    input
      padding: 12px
      border-radius: 4px
      border: 1px
      border: 1px solid #CCCCCC
      background: #FFFFFF

      &::placeholder
        color: #000000
        opacity: 30%

  input
    height: 48px

  .details
    display: flex
    gap: 16px

    label
      width: 50%

      input
        width: 100%

  .protection-text
    font-family: Poppins
    font-size: 12px
    font-weight: 500
    line-height: 18px
    text-align: center
    text-underline-position: from-font
    text-decoration-skip-ink: none
    color: #000000
    margin-top: 9px
    max-width: 235px
    align-self: center

  .info
    font-size: 13px
    font-weight: 400
    line-height: 19.5px
    text-align: center
    color: #999999
    text-wrap: pretty

.form__encryption
  font-size: 12px
  font-weight: 500
  line-height: 18px
  text-align: center
  color: #000000

.button:hover.button_animated::before
  background: #73c7f0

.button
  background: #73c7f0
  border-radius: 8px
  margin: 0
  margin-top: 14px
  width: 100%!important

  &:hover
    background: #73c7f0

  &:before
    background: rgba(115, 199, 240, 1)
    border-radius: 8px

.stripe-input
  width: 100%
  padding: 12px
  border: 1px solid #ccc
  border-radius: 4px
</style>
